import { IStoreRootState } from './interface';
import { GetterTree } from "vuex";

export default <GetterTree<IStoreRootState, IStoreRootState>> {}